import { useAccount, useConfig } from "wagmi";
import {  useCallback, useEffect, useState } from "react";
import { readContracts } from "@wagmi/core";
import W3signAbi from "../assets/abis/W3sign.json";
import REFERRALPointAbi from "../assets/abis/REFERRALPointAbi.json";
import { W3SIGN , ADDNUM , REFERRALPoint } from "../constants";
import { formatUnits } from "viem";


function  useW3Sign() {
  const { address } = useAccount()
  const config = useConfig()
  const [value, setValue] = useState(null)
  const [refreshTime, setRefreshTime] = useState(Date.now())

  useEffect(() => {
    const inc = setInterval(() => {
      setRefreshTime(Date.now())
    }, 6000)
    return () => clearInterval(inc)
  }, []);
  const fetch = useCallback(async () => {
    try {
      const results = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'getPersonalData',
            args: [address]
          }
        ]
      })


      const totalSignIn = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'totalSignIn',
            // args: [address]
          }
        ]
      })

      const todayTime = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'todayTime',
            // args: [address]
          }
        ]
      })
      const todaySignIn = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'todaySignIn',
            args: [Number(todayTime[0])]
          }
        ]
      })
      // console.log("todaySignIn",todaySignIn)
      const signIns= await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'signIns',
            args: [address,todayTime[0]]
          }
        ]
      })
      const getUserData = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'getUserData',
            args: [address]
          }
        ]
      })
      const getReferrals = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'getReferrals',
            args: [address]
          }
        ]
      })

      const boss = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: W3signAbi,
            address: W3SIGN,
            functionName: 'boss',
            args: [address]
          }
        ]
      })
      
      setValue({
        totalSignIn: Number(totalSignIn[0])+ADDNUM,
        todaySignIn: Number(todaySignIn[0]),
        boss: boss[0],
        useractivityPoints: getUserData[0][0].toString(),
        usertotalSignIns: getUserData[0][1].toString(),
        levelClaimed: getUserData[0][2],
        w3balance: parseFloat(formatUnits(results[0][0], 18)).toFixed(2),
        communitylevel: results[0][1].toString(),
        teamnums: results[0][2].toString(),
        w3claimable: parseFloat(formatUnits(results[0][3], 18)).toFixed(2),
        signIns:signIns[0],
        referrals: getReferrals[0][0],
        teampushs: getReferrals[0][1],
        activityPoints: getReferrals[0][2],
        // getTotalActivityPoints: getTotalActivityPoints[0].toString()
      })
    } catch (e) {
      console.log(e)
    }
  }, [address, config])
  const getTotalActivityPoints = useCallback(async () => {
    const getTotalActivityPoints = await readContracts(config, {
        allowFailure: false,
        contracts: [
          {
            abi: REFERRALPointAbi,
            address: REFERRALPoint,
            functionName: 'getTotalActivityPoints',
            args: [address,9]
          }
        ]
      })
      return getTotalActivityPoints[0].toString()
    },[address,config]);
  useEffect(() => {
    if (config && address) {
      fetch()
    } else {
      setValue(null)
    }
  }, [fetch, config, address, refreshTime]);

  return {value, getTotalActivityPoints}
}

export default useW3Sign